<template>
  <deviceList
    v-if="deviceTypeCode"
    :deviceTypeCode="deviceTypeCode"
    :showMonitorRangeColumn="true"
    :showOperationColumn="true"
    :showHKControlPanel="showHKControlPanel"
    :linkParam="linkParam"
    :locationSetName="locationSetName"
  >
  </deviceList>
</template>

<script>
import { DataCategoryApi } from '@wiz-api/data-category-management'
import deviceList from '../../../components/device-list'

const dataCategoryApi = new DataCategoryApi()
const deviceTypeNameKeyWord = '摄像头'
const componentName = 'cameraList'

export default {
  name: componentName,
  components: {
    deviceList,
  },
  data() {
    return {
      deviceTypeCode: '',
      deviceTypeList: [],
      linkParam: 'IOTDeviceCamera',
      locationSetName: '摄像头点位设置',
      showHKControlPanel: false, // 是否展示海康云台控制
    }
  },
  methods: {
    // 获取数据字典数据
    async getCategoryByCodes() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['IOTDeviceTemplateDeviceType'],
        includeDetails: true,
      })
      if (!err) {
        let deviceTypeList = []
        res.forEach((item) => {
          if (item.code === 'IOTDeviceTemplateDeviceType') {
            // 类型归属
            deviceTypeList = item.dataItems
          }
        })
        if (Array.isArray(deviceTypeList)) {
          for (let i = 0; i < deviceTypeList.length; i++) {
            const ele = deviceTypeList[i]
            if (ele.displayName.includes(deviceTypeNameKeyWord)) {
              this.deviceTypeCode = ele.code
            }
          }
        }
      }
    },
  },
  async created() {
    this.showHKControlPanel =
      Wiz.globalSettings.dynamicModules.modules['wiz-iot-management-tongre']?.config
        ?.showHKControlPanel || false
    this.getCategoryByCodes()
  },
}
</script>

<style lang="scss" scoped></style>
